import {create} from 'zustand';

type Store = {
  auth: boolean;
  profile?: any ,
  login: (value: boolean , data:any) => void; 
  logout: (value:boolean) => void ;
  checkStatus: (value:boolean) => void ;
  setProfile : (value:any) => void ;
};

type Language = {
  statelang : string ,
  changeLang: (value:string) => void ;
}

export const useLoggedIn = create<Store>((set) => ({
  auth: false,
  profile : {},
  setProfile : (value:any) => set((state)=> ({profile:value})),
  login: (value: boolean , data:any) => set((state) => ({ auth: value , profile:data })),
  logout: (value:boolean) => set(()=>({auth:value , profile: {}})),
  checkStatus: (value:boolean) => set(()=>({auth:value , profile: {}}))
   
}));

export const currentLanguage = create<Language>((set) => ({
  statelang :'en',
    changeLang : (value : string) => set(()=> ({statelang:value}))
}));

